import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hd-experiment-page',
  standalone: false,
  templateUrl: './hd-experiment-page.component.html',
  styleUrl: './hd-experiment-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdExperimentPageComponent {}
